// src/components/Button.jsx
import React from "react";
import PropTypes from "prop-types";

const baseClasses = `
  inline-flex items-center justify-center
  w-auto
  px-4 py-1
  min-h-[60px]
  rounded-[6px]
  font-sans font-bold
  text-base
  transition-colors
  focus:outline-none
  focus:ring-2
`;

const variants = {
  primary: {
    "dark-green": `
      bg-primary-dark text-beige border border-transparent
      hover:bg-transparent hover:text-primary-dark hover:border-primary-dark
      focus:ring-primary-dark
    `,
    terracotta: `
      bg-accent text-beige border border-transparent
      hover:bg-transparent hover:text-accent hover:border-accent
      focus:ring-accent
    `,
  },
  secondary: {
    "dark-green": `
      bg-transparent text-white border border-white 
      hover:bg-white hover:text-primary-dark hover:border-primary-dark
      focus:ring-primary-dark
    `,
    terracotta: `
      bg-white text-accent border border-accent
      hover:bg-accent hover:text-beige hover:border-accent
      focus:ring-accent
    `,
  },
};

export default function Button({
  children,
  variant = "primary", // "primary" ou "secondary"
  color = "dark-green", // "dark-green" ou "terracotta"
  className = "",
  as = "button",
  ...props
}) {
  const Component = as;
  return (
    <Component
      className={`${baseClasses} ${variants[variant][color]} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary"]),
  color: PropTypes.oneOf(["dark-green", "terracotta"]),
  className: PropTypes.string,
  as: PropTypes.elementType,
};
